import type { AlertColor, SxProps, Theme } from "@mui/material";

type ToastDetailType = {
	title?: string;
	message: string;
	severity: AlertColor;
	sx?: SxProps<Theme>;
	autoHideDuration?: number;
	closableToast?: boolean;
};

const successToast = (msg = "Success!", sx?: SxProps<Theme>) => {
	toast({
		message: msg,
		severity: "success",
		sx
	});
};

const errorToast = (msg: string, sx?: SxProps<Theme>) => {
	toast({
		message: msg,
		severity: "error",
		sx
	});
};

const warningToast = (msg: string, sx?: SxProps<Theme>) => {
	toast({
		message: msg,
		severity: "warning",
		sx
	});
}

const customToast = ({title, message, severity, sx, autoHideDuration, closableToast}: {title: string, message: string, severity: AlertColor, sx?: SxProps<Theme>, autoHideDuration: number, closableToast: boolean})  => {
	toast({
		title,
		message,
		severity,
		sx,
		autoHideDuration,
		closableToast
	});
}

const toast = ({ title, message, severity, sx, autoHideDuration, closableToast }: ToastDetailType) => {
	const event = new CustomEvent<ToastDetailType>("toast", {
		detail: {
			title,
			message,
			severity,
			sx,
			autoHideDuration,
			closableToast
		},
	});

	window.dispatchEvent(event);
};

export { errorToast, successToast, warningToast, customToast };
